module.exports = require("jquery");


//////////////////
// WEBPACK FOOTER
// external "jquery"
// module id = 9
// module chunks = 0